const mcuCheckinRoutes = [
    {
        path: '/mcu-checkin',
        name: 'mcuCheckin',
        children: [
            {
                path: '',
                name: 'mcuCheckinList',
                component: () => import('@/modules/mcu_checkin/list/List.vue'),
                meta: {
                    resource: 'bookings',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'MCU Day Check-in',
                    breadcrumbs: [{ title: 'MCU Day Check-in', routeName: 'mcuCheckinList' }]
                }
            }
        ]
    }
]

export default mcuCheckinRoutes
